import { Component, Input } from "@angular/core";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { GenericErrorComponent } from "@ponder-shared/components/errors/generic-error.component";

@Component({
    selector: "loading",
    imports: [BusySpinComponent, GenericErrorComponent],
    templateUrl: "./loading.component.html"
})
export class LoadingComponent {
    @Input({ required: true }) isLoading: boolean = true;
    @Input({ required: true }) success: boolean = false;
}